import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Trip } from '../../../DataStructures/Trip/Trip';
import * as moment from 'moment';
import { DateConstants } from '../../../utilities/WeekSchedule/DateConstants';
import { VehicleSuggestion } from '../../../utilities/VehicleSuggestion/VehicleSuggestion';
import { VehicleScheduler } from '../../../utilities/Scheduling/VehicleScheduler';
import { Week } from '../../../DataStructures/Week/Week';
import { WeekService } from '../../../services/week-service/week.service';
import { QuickDialog } from '../../../utilities/Dialog/QuickDialog';
import { VehicleReservation } from '../../../DataStructures/VehicleReservation/VehicleReservation';
import { RunConfig } from '../../../DataStructures/RunConfiguration/RunConfig';
import { VehicleService } from '../../../services/vehicle-service/vehicle.service';
import { Vehicle } from '../../../DataStructures/Vehicle/Vehicle';
import { Suggestion } from '../../../utilities/VehicleSuggestion/Suggestion';
import { MapQuestDirectionsService } from '../../../utilities/MapQuest/DirectionsServiceMapQuest';
import { MapquestService } from '../../../services/map-quest/mapquest.service';
import { RouteOptions } from '../../../DataStructures/RunConfiguration/RouteOptions';
import { LocationOptions } from '../../../shared/location-picker/location-picker.component';

@Component({
  selector: 'app-map-window-dialog',
  templateUrl: './map-window-dialog.component.html',
  styleUrls: ['./map-window-dialog.component.css']
})
export class MapWindowDialogComponent implements OnInit {

  trip: Trip;
  index: number;
  dropOffTime: string;
  passenger: string;
  address: string;
  scheduler: VehicleScheduler;
  runConfig: RunConfig;
  sendBackupEnabled = true;
  reportId: string;
  breakdownMode = false;
  options:LocationOptions = {
    searchBoxText:"Enter Break Down Location"
  };

  constructor(private mapQuestDirections: MapquestService, private vehicleService: VehicleService, private weekService: WeekService, private dialog: MatDialog, public dialogRef: MatDialogRef<MapWindowDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: MapDialogData) {
    this.trip = data.trip;
    this.index = data.index;
    this.trip.calculateDropProperties();
    this.dropOffTime = moment(this.trip.areas[this.index].dropOffTime.toString()).format(DateConstants.standardDateTimeFormat);
    this.passenger = this.trip.areas[this.index].destinations[0].person;
    this.address = this.trip.areas[this.index].address;
    this.runConfig = data.runConfig;
  }

  ngOnInit() {
    this.weekService.getWeek(this.runConfig.week.weekid).then((res: any) => {
      if (res.status) {
        if (res.data != null) {
          if (res.data.reportid != null) {
            this.sendBackupEnabled = false;
            this.reportId = res.data.reportid;
          }
        }
      } else {
        new QuickDialog(this.dialog).InfoDialog(res.message, "Error", "OK");
      }
    }).catch(e => {
      new QuickDialog(this.dialog).InfoDialog(e, "Error", "OK");
    })
  }

  enterBreakDownMode(){
    
    this.breakdownMode = true;
  }

  getSuggestedBackupVehicle(): Promise<Trip> {

    return new Promise(async (resolve, reject) => {

      var leftOvers = this.trip.areas.slice(this.index);
      var source = this.trip.source;
      var t = new Trip(source, source, leftOvers,this.trip.pickupType);
      var vehicles = new Array<Vehicle>();
      var vehicle: Vehicle = null;
      var reserves = this.runConfig.week.schedule.find(s => s.time == "reserves");



      if (reserves.vehicles.length > 0) {

        vehicles = vehicles.concat(Vehicle.convertVehicleResponseToVehicles(reserves.vehicles));

        //Try to use non contractors first
        var vehicleRatio = VehicleSuggestion.getBestFitVehicles([t], vehicles.filter(x => VehicleScheduler.driverShiftEnded(x, "Sun Jan 07 2018 9:00 PM") == false && x.contracted == 0));

        //No non contractors
        if (vehicleRatio[0].vehicle == null) {
          vehicleRatio = VehicleSuggestion.getBestFitVehicles([t], vehicles.filter(x => VehicleScheduler.driverShiftEnded(x, "Sun Jan 07 2018 9:00 PM") == false));
        }

        if (vehicleRatio[0].vehicle != null) {
          t.vehicleReservation = new VehicleReservation(vehicleRatio[0].vehicle);
          t.vehicleReservation.assignToNewTrip(t);
        } else {
          this.contractVehicle(t).then(Suggestion => {
            t.vehicleReservation = Suggestion[0].vehicleReservation;
            t.vehicleReservation.assignToNewTrip(t);
            resolve(null);
          }).catch(e => { reject(e) })
        }
      } else {
        this.contractVehicle(t).then(Suggestion => {
          t.vehicleReservation = Suggestion[0].vehicleReservation;
          t.vehicleReservation.assignToNewTrip(t);
          resolve(null);
        }).catch(e => { reject(e) })
      }

      t.getDirections(new MapQuestDirectionsService(this.mapQuestDirections), {
        avoidTolls: RouteOptions.avoidTolls
      }).then(trip => {
        resolve(trip);
      }).catch(e => reject(e))
    });
  }

  contractVehicle(trip: Trip): Promise<Array<Suggestion>> {

    return new Promise((resolve, reject) => {
      new VehicleSuggestion(this.vehicleService, this.runConfig).getSuggestions([trip]).then(suggestion => {
        resolve(suggestion);
      }).catch(e => {
        reject(e);
      })
    })
  }

  locationSelected(event){
    console.log(event);
  }
}

export interface MapDialogData {
  trip: Trip;
  index: number;
  runConfig: RunConfig;
}
